/* -------------------------------------------------------------------------
 * With the design toggle ON the `src/antd` Select and Dropdown seams re-emit
 * none of antd's class names — their DOM contract is `data-slot` — and both
 * mount their popup inside the trigger's parent, i.e. inside whatever row or
 * panel a runtime guard is protecting. Any `closest()` guard written against
 * `.ant-select` / `.ant-dropdown` therefore needs these selectors beside them,
 * the same way the stylesheets grew a `[data-slot='…']` twin.
 * ---------------------------------------------------------------------- */
export const SEAM_OVERLAY_SELECTOR =
  "[data-slot='select'], [data-slot='select-dropdown'], [data-slot='dropdown-menu-trigger'], [data-slot='dropdown-menu-content']"

/* -------------------------------------------------------------------------
 * The DatePicker seam is the same story: with the toggle ON its shell is
 * `[data-slot='picker']` and its panel is a Radix `PopoverContent` carrying
 * `[data-slot='picker-dropdown']`, so a `closest()` guard written against
 * `.ant-picker` needs these beside it.
 * ---------------------------------------------------------------------- */
export const SEAM_PICKER_SELECTOR =
  "[data-slot='picker'], [data-slot='picker-dropdown']"

/** The seam's twin of `.ant-picker-input`. */
export const SEAM_PICKER_INPUT_SELECTOR = "[data-slot='picker-input']"

/**
 * The seam's twin of `.ant-picker-ok button` — the seam's OK IS the button,
 * where antd nests one inside an `.ant-picker-ok` wrapper.
 */
export const SEAM_PICKER_OK_SELECTOR = "[data-slot='picker-ok']"
